import $ from 'jquery';

export function initHandleiding() {
	$( "#footer" ).hide();

	$("#mobileNavButtonLeft").click(function(){
		$("#manualNav").slideToggle(200);
		$(this).children('i').toggleClass('fa-list fa-times');
		window.scrollTo(0, 0);
	});
}
